import { render, staticRenderFns } from "./DeliveryReminder.vue?vue&type=template&id=29a46426"
import script from "./DeliveryReminder.vue?vue&type=script&lang=js"
export * from "./DeliveryReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports